<template>
  <div @click="setIndex" :class="[btnStyle[currentIndex]]">

    <span class="tech-btn-corner tech-btn-corner-1"></span>
    <span class="tech-btn-corner tech-btn-corner-2"></span>
    <span class="tech-btn-corner tech-btn-corner-3"></span>
    <span class="tech-btn-corner tech-btn-corner-4"></span>
    <div class="tech-btn-txt"><span :title="__value" v-text="__value"></span></div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      currentIndex: 0
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    // currentIndex: {
    //   type: Number,
    //   default: 0
    // },
    isStateful: {
      type: Boolean,
      default: false
    },
    isChangeable: {
      type: Boolean,
      default: true
    },
    btnStyle: {
      type: Array,
      default: function () { return ['tech-btn-not-selected', 'tech-btn-selected'] }
    },
    txtList: {
      type: Array,
      default: function () { return [] }
    }
  },
  computed: {
    // __index: {
    //   get () {
    //     return this.currentIndex
    //   },
    //   set (val) {
    //     this.$emit('update:currentIndex', val)
    //   }
    // },
    __value: {
      get () {
        // console.log(this.currentIndex)
        return this.value
      },
      set (val) {
        this.$emit('update:value', val)
      }
    }
  },
  methods: {
    setIndex () {
      if (this.isChangeable) {
        this.currentIndex = 1 - this.currentIndex
        // this.__index = 1 - this.__index
        // console.log(this.__index)
      }
      // 以下代码仅用于需要保存按钮状态的特殊按钮,整个项目中，仅允许有一个特殊按钮
      if (this.isStateful) {
        this.$store.commit('GET_MENU_STATUS', this.__value)
      }
      this.__value = (this.__value === this.txtList[0]) ? this.txtList[1] : this.txtList[0]
    }
  }
}
</script>

<style lang="scss">
.tech-btn-selected {
  position: relative;
  pointer-events: auto;
  width: 100px;
  height: 40px;
  font-size: 16px;
  color: #fec819;
  line-height: 40px;
  text-align: center;
  vertical-align: middle;
  background: #152536;
  border: 1px solid #fec819;
  margin-bottom: 16px;
  cursor: pointer;
}

.tech-btn-not-selected {
  position: relative;
  pointer-events: auto;
  width: 100px;
  height: 40px;
  font-size: 16px;
  color: #00edff;
  line-height: 40px;
  text-align: center;
  vertical-align: middle;
  background: #152536;
  border: 1px solid #0a899a;
  margin-bottom: 16px;
  cursor: pointer;
}

.tech-btn-selected > .tech-btn-corner {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAADJJREFUOBFj/HdC8j8DFQATFcwAGzH4DGJB9xqTxXNGdDFi+IPPa6MuIhxvo2E0osMIAIu3BCbBSg+UAAAAAElFTkSuQmCC);
}

.tech-btn-not-selected > .tech-btn-corner {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAADFJREFUOBFjZHj7/z8DFQATFcwAGzH4DGLB8JowIyOGGBECg89roy4iHG2jYTSiwwgArh8DJqrMqvIAAAAASUVORK5CYII=);
}

.tech-btn-txt {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.tech-btn-corner {
  position: absolute;
  width: 9px;
  height: 9px;
  background-size: 9px 9px;
  background-repeat: no-repeat;
}

.tech-btn-corner-1 {
  top: -2px;
  left: -2px;
}

.tech-btn-corner-2 {
  top: -2px;
  right: -2px;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.tech-btn-corner-3 {
  right: -2px;
  bottom: -2px;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.tech-btn-corner-4 {
  left: -2px;
  bottom: -2px;
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}
</style>



// WEBPACK FOOTER //
// src/components/tech/tech-btn.vue